module.exports = {
	colors: {
		main: '#44147c',
		sec: '#79c912',
		alt: '#44147c',
	},

	showFunds: false,
	showBuses: false,
	showHomeworks: true,
	useCourses: false,
	useUploadChatImage: false,

	about: {
		mobiles: ['0967953490', '0995288898'],
		phones: [],
		address: '',
		data: [],
		email: null,
		facebook: '',
		privacy: null,
		details: [
			{
				title: 'عن سوا',
				content: [
					'برؤية إدارية جديدة ضمن الأكاديمية وقاعات نموذجية مكيفة تؤمن لطلاب الشهادتين الجو الدراسي الأمثل بأعداد نموذجية واتباع وسائل إدارية وتدريسية حديثة',
					'نسعى لبناء طلابنا أخلاقياً أولاً ثمّ تعليمياً...من خلال جعل الأخلاق مقترنة بالتعليم وذلك بتطبيق نظام تربوي حضاري يرسّخ المبادئ والقيم الأخلاقية السليمة حريصين على انتقاء كادرنا التربوي بعناية فائقة ليكون مزيجاً من الخبرات المتراكمة مع روح الشباب ، واضعين نصب أعيننا رؤية مستقبليةً لغرس ثقافةَ العلم والتعليم في القلوب قبل العقول..',
					'الحلم يبدأ من هنا وينتهي بالتميّيز  والإبداع والتفوق...',
					'⭐️ســــوا مصنع النجوم...✨📚💚',
					'⭐️كُن أنتَ نجمَ المرحلة القادمة...✨📚💚',
				],
			},
		],
	},

	pwa: {
		name: 'Edunix - Sawa academy app',
		shortName: 'Sawa academy app',
		description: 'Edunix - Sawa academy app - portal version for Sawa mobile app.',
	},
};
